<script setup lang="ts">
import type { SoMeIcon } from 'types';
import IconsFacebookIcon from '~/components/global/Icons/FacebookIcon.vue';
import IconsInstagramIcon from '~/components/global/Icons/InstagramIcon.vue';
import IconsLinkedInIcon from '~/components/global/Icons/LinkedInIcon.vue';

defineProps<{
  icons: SoMeIcon[];
}>();

const iconComponents = {
  facebook: IconsFacebookIcon,
  instagram: IconsInstagramIcon,
  linkedin: IconsLinkedInIcon
} as const;

type IconName = keyof typeof iconComponents;

const getIconComponent = (iconName: IconName) => iconComponents[iconName];
</script>

<template>
  <ul
    class="flex gap-6 lg:justify-end lg:gap-8"
    :aria-label="$t('Aria.Global.Footer.SoMeList')"
  >
    <template v-for="icon in icons">
      <li
        v-if="icon.link"
        :key="icon.icon"
        class="flex items-center justify-center"
      >
        <a
          class="flex lg:h-8"
          target="_blank"
          rel="noopener noreferrer"
          :href="icon.link"
          :title="icon.title"
          :aria-label="icon.title"
        >
          <component :is="getIconComponent(icon.icon as IconName)" />
        </a>
      </li>
    </template>
  </ul>
</template>
